import clsx from "clsx"
import { KeyboardEvent, MouseEvent } from "react"

import styles from "./Card.module.scss"
import { CardProps } from "./Card.types"

export default function Card(props: CardProps) {
    const {
        children,
        className,
        onClick,
        _isFocused = false,
        _isHovered = false,
        isPressed = false,
        isDisabled = false,
        isLoading = false,
    } = props

    if (!onClick) {
        return <div className={clsx(styles.base, className)}>{children}</div>
    }

    const isInteractionBlocked = isDisabled || isLoading

    function handleKeyDown(event: KeyboardEvent<HTMLDivElement>) {
        if (isInteractionBlocked) {
            return
        }
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            onClick?.(event as unknown as MouseEvent<HTMLDivElement>)
        }
    }

    function handleClick(event: MouseEvent<HTMLDivElement>) {
        if (isInteractionBlocked) {
            return
        }
        onClick?.(event)
    }

    return (
        <div
            role="button"
            tabIndex={isInteractionBlocked ? -1 : 0}
            aria-disabled={isInteractionBlocked}
            aria-busy={isLoading}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={clsx(
                styles.base,
                styles.isInteractive,
                {
                    [styles.isFocused]: _isFocused,
                    [styles.isHovered]: _isHovered,
                    [styles.isPressed]: isPressed,
                    [styles.isDisabled]: isDisabled,
                    [styles.isLoading]: isLoading,
                },
                className,
            )}
        >
            {children}
        </div>
    )
}
